import { Controller } from "@hotwired/stimulus"

export default class WithdrawCryptoConfirmationController extends Controller {
    static targets = ["form", "loadingSpinner", "confirmButton", "buttonText"]

    handleConfirmClick(event) {
        event.preventDefault();
        
        if (this.isLoading) {
            return false;
        }
        
        if (this.hasFormTarget && !this.formTarget.checkValidity()) {
            this.formTarget.reportValidity();
            return false;
        }
        
        this.showLoading();
        
        if (this.hasFormTarget) {
            this.formTarget.requestSubmit();
        }
    }

    showLoading() {
        this.isLoading = true;
        
        if (this.hasConfirmButtonTarget) {
            this.confirmButtonTarget.disabled = true;
            this.confirmButtonTarget.classList.add("pointer-events-none", "opacity-50");
        }
        
        if (this.hasLoadingSpinnerTarget) {
            this.loadingSpinnerTarget.classList.remove("hidden");
        }
        
        if (this.hasButtonTextTarget) {
            this.buttonTextTarget.textContent = "Processing...";
        }
    }

    hideLoading() {
        this.isLoading = false;
        
        // Enable button
        if (this.hasConfirmButtonTarget) {
            this.confirmButtonTarget.disabled = false;
            this.confirmButtonTarget.classList.remove("pointer-events-none", "opacity-50");
        }
        
        // Hide spinner
        if (this.hasLoadingSpinnerTarget) {
            this.loadingSpinnerTarget.classList.add("hidden");
        }
        
        // Reset button text
        if (this.hasButtonTextTarget) {
            this.buttonTextTarget.textContent = "Confirm";
        }
    }

    onSubmitStart(event) {
        if (!this.isLoading) {
            this.showLoading();
        }
    }

    onSubmitEnd(event) {
        if (event.detail && event.detail.success === false) {
            this.hideLoading();
        }
    }
}

